import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getGamePickerState } from '../store/selectors/gamePickerSelector';
import GamePicker from '../GamePicker';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import gamePickerReducer from '../store/reducers/gamePicker';
import MessageService from 'message-service/message-service';
import HashEvents from '@gameday/core-legacy/lib/enum/HashEvents';
import { useTheme } from '@gameday/utils/hooks/useTheme';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

const { GAME_ID_CHANGED } = HashEvents;

initContainerData.register({
    reducers: {
        gamePicker: gamePickerReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: [
        // ...TeamSummaryMatchupRoutes,
        // ...WrapRoutes
    ]
}];

const GamePickerContainer = (props) => {
    const { gameCardMode, gameChangeHandler } = props;
    const gamePickerState = useSelector(getGamePickerState);
    const { date } = gamePickerState;
    const theme = useTheme();
    const mergedGameChangeHandler = useCallback((gamePk) => {
        MessageService.publish(GAME_ID_CHANGED, gamePk);
        if (gameChangeHandler) {
            gameChangeHandler(gamePk);
        }
    }, []);
    return (
        date
            ? <ErrorBoundaryWrapper componentName='GamePicker container' horizontal={gameCardMode !== 'vertical'}>
                <GamePicker
                    gameCardMode={ gameCardMode }
                    gameChangeHandler={ mergedGameChangeHandler }
                    theme={ theme }
                    { ...gamePickerState }
                />
            </ErrorBoundaryWrapper>
            : null
    );
};

GamePickerContainer.propTypes = {
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    gameChangeHandler: PropTypes.func,
    gameCardMode: PropTypes.string
};

export default GamePickerContainer;
export { routes };
